<router-outlet></router-outlet>
<ngx-spinner>
    <p class="mt-5" style="color: white" >{{ ds?.spinnerTxt }}</p>
</ngx-spinner>